import type { Locale } from '../content/site'
import { site } from '../content/site'

const COPY = {
  title: { en: 'Desktop only', ru: 'Только для компьютера' },
  body: {
    en: 'This site is an interactive shell and needs a physical keyboard. Open it on a desktop browser.',
    ru: 'Этот сайт — интерактивный терминал, ему нужна физическая клавиатура. Откройте его на компьютере.',
  },
  links: { en: 'In the meantime:', ru: 'А пока:' },
  now: { en: 'Now', ru: 'Сейчас' },
} as const

/**
 * Phones get this instead of the terminal. It still exposes the identity and the
 * public links, so a phone visitor is not sent away with nothing.
 */
export function DeviceNotice({ locale }: { locale: Locale }) {
  return (
    <main className="device-notice" lang={locale}>
      <div>
        <p className="device-notice__prompt" aria-hidden="true">
          &gt;_
        </p>
        <h1>{COPY.title[locale]}</h1>
        <p>{COPY.body[locale]}</p>
        <p className="device-notice__now">
          <span>{COPY.now[locale]}:</span> {site.work.role[locale]} —{' '}
          <a href={site.work.url} target="_blank" rel="noreferrer">
            {site.work.company}
          </a>
        </p>
        <p className="device-notice__label">{COPY.links[locale]}</p>
        <ul className="device-notice__links">
          {site.links.map((item) => (
            <li key={item.url}>
              <a href={item.url} target="_blank" rel="noreferrer">
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </main>
  )
}
